export default __webpack_public_path__ + "static/media/stanza3.952fe45d.JPG";